// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "@/assets/css/reset.css";
import "@/assets/css/swiper.css";
import "lib-flexible/flexible";
import Layout from "./components/Layout";
import {
  DropdownMenu,
  DropdownItem,
  Overlay,
  Swipe,
  SwipeItem,
  Form,
  Field,
  Button,
  Toast,
  Popup,
  Picker,
  Loading,
  Lazyload,
  Row,
  Col,
  Rate,
  CountDown
} from "vant";

router.afterEach((to, from, next) => {
    document.title = to.meta.title
  window.scrollTo(0, 0);
});

Vue.use(DropdownMenu)
  .use(DropdownItem)
  .use(Overlay)
  .use(Swipe)
  .use(SwipeItem)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Popup)
  .use(Picker)
  .use(Loading)
  .use(Lazyload)
  .use(Toast)
  .use(Row)
  .use(Col)
  .use(Rate)
  .use(CountDown)

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js